import React, { memo, useMemo } from 'react';

// Et pixelkort som inline SVG: ét <rect> pr. celle, ingen anti-aliasing. Tegn der ikke står i paletten er gennemsigtige.
function PixelSprite({ map, palette, cell = 3 }) {
  const rows = map.length;
  const cols = map[0]?.length || 0;
  const rects = useMemo(() => {
    const out = [];
    map.forEach((row, y) => {
      [...row].forEach((ch, x) => {
        const fill = palette[ch];
        if (fill) out.push(<rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill={fill} />);
      });
    });
    return out;
  }, [map, palette]);

  return (
    <svg
      width={cols * cell}
      height={rows * cell}
      viewBox={`0 0 ${cols} ${rows}`}
      shapeRendering="crispEdges"
      aria-hidden="true"
      style={{ display: 'block' }}
    >
      {rects}
    </svg>
  );
}

export default memo(PixelSprite);
